import { Link, useNavigate } from "react-router-dom";
import {
  BarChart3,
  CalendarDays,
  Check,
  CirclePlay,
  Goal,
  Infinity,
  Landmark,
  Lock,
  Trophy,
  Users,
} from "lucide-react";
import { useEffect, useState } from "react";
import axios from "../../../../axios";
import CourseActivatedModal from "./CourseActivatedModal";
import { toast } from "react-toastify";

const getSelectedStateId = (userData) => {
  const selectedState =
    userData?.selectedState?._id ||
    userData?.selectedState ||
    userData?.state?._id ||
    userData?.state ||
    userData?.stateId ||
    localStorage.getItem("stateId");

  return selectedState ? String(selectedState) : "";
};

const CourseCard = ({ plan }) => {
   const navigate = useNavigate();
  const [hasPurchased, setHasPurchased] = useState(false);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [showActivatedModal, setShowActivatedModal] = useState(false);
useEffect(() => {
  const fetchUser = async () => {
    try {
      const response = await axios.get("me");

      const userData = response?.data?.result;
      setSelectedStateId(getSelectedStateId(userData));

      if (
        userData?.planName !== "Test" &&
        userData?.planName === plan?.planName
      ) {
        setHasPurchased(true);
      } else {
        setHasPurchased(false);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  fetchUser();
}, [plan?.planName]);

useEffect(() => {
  if (!hasPurchased || !plan?._id) return;

  const popupKey = `course_activated_${plan._id}`;

  if (!localStorage.getItem(popupKey)) {
    setShowActivatedModal(true);
    localStorage.setItem(popupKey, "shown");
  }
}, [hasPurchased, plan?._id]);

  const discount =
    plan?.price && plan?.offerPrice
      ? Math.round(((plan.price - plan.offerPrice) / plan.price) * 100)
      : null;
  const totalQuestions =
    plan?.totalQuestions || plan?.questionCount || plan?.questions?.length || "100K+";
  const earningText = plan?.earningText || plan?.earnUpTo || "10K+ Earn up to";
  const offerLabel = hasPurchased ? "ACTIVE" : "SPECIAL OFFER";
  const unlockLabel = hasPurchased ? "Start Now" : "Unlock Test";
  const featureItems = [
    { label: "Unlimited Questions", Icon: Infinity },
    { label: "Real Exam Level", Icon: Goal },
    { label: "Performance Analysis", Icon: BarChart3 },
    { label: "Earn Credits & Rewards", Icon: Trophy },
    { label: "Daily New Questions", Icon: CalendarDays },
  ];

  const handleOpenMockTest = async () => {
    if (!plan?._id) {
      toast.error("Course ID was not found");
      return;
    }

    const stateId = selectedStateId || localStorage.getItem("stateId");
    const stateQuery = stateId ? `?stateId=${encodeURIComponent(stateId)}` : "";

    navigate(`/dash/mock-test/${plan._id}${stateQuery}`);
  };

  return (
    <>
    
    <div className="mx-auto w-full max-w-[560px] overflow-hidden rounded-[1.6rem]">
     
      <div className="relative overflow-hidden rounded-t-[1.35rem] bg-[#552062] px-5 pb-6 pt-12 text-white sm:mx-5 sm:px-6">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_10%,rgba(255,255,255,0.18),transparent_30%),radial-gradient(circle_at_78%_26%,rgba(255,166,35,0.15),transparent_28%)]" />
        <div
          className={`absolute left-0 top-0 z-10 inline-flex items-center gap-1.5 rounded-br-[1rem] px-4 py-1.5 text-xs font-bold uppercase text-[#4B1F5D] ${
            hasPurchased ? "bg-[#B9F5C6]" : "bg-[#F6A91A]"
          }`}
        >
          {hasPurchased ? <Check className="h-4 w-4" /> : <span>*</span>}
          {offerLabel}
        </div>
        {discount !== null && (
          <div className="absolute right-4 top-0 z-10 rounded-b-[1rem] bg-[#F23567] px-4 py-2 text-center text-xs font-bold uppercase leading-4 text-white shadow-sm">
            {discount}%<br />OFF
          </div>
        )}

        <div className="relative z-10 flex items-center gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[1.25rem] bg-[#F4FFF2] text-[#552062] shadow-[inset_0_0_0_1px_rgba(85,32,98,0.08)]">
            <Landmark className="h-8 w-8 fill-[#552062]/10" />
          </div>

          <div className="min-w-0 flex-1">
            <h2 className="line-clamp-2 text-xl font-bold leading-tight text-white sm:text-xl">
              {plan?.planName}
            </h2>
            <p className="mt-2 text-[10px] font-medium text-white/82 sm:text-[10px]">
              Unlimited Questions - Practice - Analyze - Earn Rewards
            </p>
          </div>
        </div>

        <div className="relative z-10 mt-2 grid grid-cols-2 gap-3">
          <span className="inline-flex min-w-0 items-center justify-center gap-2 rounded-full bg-white/10 px-3 py-2 text-xs font-semibold text-white shadow-[inset_0_0_0_1px_rgba(255,255,255,0.08)] sm:text-sm">
            <Users className="h-4 w-4 shrink-0" />
            <span className="truncate">{earningText}</span>
          </span>
          <span className="inline-flex min-w-0 items-center justify-center gap-2 rounded-full bg-white/10 px-3 py-2 text-xs font-semibold text-white shadow-[inset_0_0_0_1px_rgba(255,255,255,0.08)] sm:text-sm">
            <CirclePlay className="h-4 w-4 shrink-0" />
            <span className="truncate">{totalQuestions} Questions</span>
          </span>
        </div>
      </div>

      <div className="px-4 py-3 sm:px-5 bg-white/90">
        <div className="grid grid-cols-5 gap-2 border-b border-[#E9DFEA] pb-4">
          {featureItems.map(({ label, Icon }) => (
            <div key={label} className="min-w-0 text-center">
              <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-[#F7F1F8] text-[#552062] shadow-sm">
                <Icon className="h-5 w-5" />
              </div>
              <p className="mt-2 text-[10px] font-semibold leading-4 text-[#4D3B56] sm:text-xs">
                {label}
              </p>
            </div>
          ))}
        </div>

      
        <div
          className={`mt-3 grid gap-3 ${
            hasPurchased ? "grid-cols-1" : "grid-cols-[1fr_1.05fr]"
          }`}
        >
          {!hasPurchased && (
            <button
              type="button"
              onClick={handleOpenMockTest}
              className="flex min-h-[70px] min-w-0 items-center gap-3 rounded-[1.2rem] border border-[#F23567] bg-white px-2 text-left text-[#552062] shadow-sm transition hover:scale-[0.98] sm:px-4"
            >
              <span className="flex shrink-0 items-center justify-center rounded-full border border-[#552062]">
                <CirclePlay className="h-6 w-6 fill-[#552062]/10" />
              </span>
              <span className="min-w-0">
                <span className="block text-lg font-bold leading-tight sm:text-2xl">
                  Try Free Test
                </span>
                <span className="mt-1 block truncate text-[10px] font-semibold text-[#6D6274] sm:text-xs">
                  Try before you buy
                </span>
              </span>
            </button>
          )}

          <Link
            to={hasPurchased ? "/dash/quize" : `/dash/checkout/${plan?._id}`}
            className="min-w-0"
          >
            <button
              className={`flex min-h-[72px] w-full min-w-0 items-center rounded-[1.2rem] px-3 text-white shadow-[0_12px_20px_rgba(85,32,98,0.28)] transition hover:scale-[0.98] sm:px-2 ${
                hasPurchased
                  ? "justify-center bg-[#F5A623] text-center"
                  : "gap-3 bg-[#552062] text-left"
              }`}
            >
              {hasPurchased ? (
                <span className="text-xl font-bold leading-tight sm:text-2xl flex gap-4">
                 <CirclePlay className="text-white"></CirclePlay> Start Now
                </span>
              ) : (
                <>
                  <Lock className="h-6 w-6 text-white/30 shrink-0" />
                  <span className="min-w-0">
                    <span className="block text-xs font-bold leading-none text-white/60 line-through sm:text-sm">
                      RS.{plan?.price}
                      <span className="ml-2 text-lg text-white no-underline sm:text-2xl">
                        RS.{plan?.offerPrice}
                      </span>
                    </span>
                    <span className="mt-1 block text-base font-bold leading-tight sm:text-xl">
                      {unlockLabel}
                    </span>
                    <span className="block truncate text-[10px] font-semibold text-white/60 sm:text-xs">
                      Start Unlimited Practice
                    </span>
                  </span>
                </>
              )}
            </button>
          </Link>
        </div>
      </div>
    </div>
    <CourseActivatedModal
  isOpen={showActivatedModal}
  onClose={() => setShowActivatedModal(false)}
  courseName={plan?.planName}
  onStartLearning={() => {
    setShowActivatedModal(false);
    window.location.href = "/dash/quize";
  }}
  onGoDashboard={() => {
    setShowActivatedModal(false);
    window.location.href = "/dashboard";
  }}
/>
    </>
  );
};

export default CourseCard;
